// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-title {
  font-weight: 37.5rem;
  font-size: 1rem;
}

/* th,
tr {
  font-size: 1rem;
} */

.table-container-usage {
  max-height: 28.125rem;
  overflow-y: auto;
}

.table-container-status {
  max-height: 28.125rem;
  overflow-y: auto;

}

.table {
  width: 100%;
  border-collapse: collapse;
}

.table th,
.table td {
  padding: 8px;
}

.card {
  background-color: #ffffff;
  border-radius: 0%;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);

}



@media (max-width:600px) {
  .custom-card {
    width: 100%;
  }

}

@media (min-width:600px) {
  .custom-card {
    width: 100%;
  }
}

@media (min-width:768px) {
  .custom-card {
    width: 19.65%;
  }
}

@media(max-width:1300px) {

 
  th,
  tr,
  .card-title {
    font-size: 14px;
  }

  h6,
  h1{
    font-size: 18px;
  }
}

.custom-card-row {
  column-gap: 5px;

}`, "",{"version":3,"sources":["webpack://./src/Pages/Dashboard.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,eAAe;AACjB;;AAEA;;;GAGG;;AAEH;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;;AAElB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,+CAA+C;;AAEjD;;;;AAIA;EACE;IACE,WAAW;EACb;;AAEF;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;;;EAGE;;;IAGE,eAAe;EACjB;;EAEA;;IAEE,eAAe;EACjB;AACF;;AAEA;EACE,eAAe;;AAEjB","sourcesContent":[".card-title {\n  font-weight: 37.5rem;\n  font-size: 1rem;\n}\n\n/* th,\ntr {\n  font-size: 1rem;\n} */\n\n.table-container-usage {\n  max-height: 28.125rem;\n  overflow-y: auto;\n}\n\n.table-container-status {\n  max-height: 28.125rem;\n  overflow-y: auto;\n\n}\n\n.table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.table th,\n.table td {\n  padding: 8px;\n}\n\n.card {\n  background-color: #ffffff;\n  border-radius: 0%;\n  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);\n\n}\n\n\n\n@media (max-width:600px) {\n  .custom-card {\n    width: 100%;\n  }\n\n}\n\n@media (min-width:600px) {\n  .custom-card {\n    width: 100%;\n  }\n}\n\n@media (min-width:768px) {\n  .custom-card {\n    width: 19.65%;\n  }\n}\n\n@media(max-width:1300px) {\n\n \n  th,\n  tr,\n  .card-title {\n    font-size: 14px;\n  }\n\n  h6,\n  h1{\n    font-size: 18px;\n  }\n}\n\n.custom-card-row {\n  column-gap: 5px;\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
